/**
 * Filterable Posts – front-end behaviour.
 *
 * Vanilla JS (no jQuery dependency). Handles:
 *   • Dropdown open/close
 *   • Checkbox selection → Apply / Clear Filters
 *   • "ALL" reset button
 *   • Load More (via WP REST API)
 */
(function () {
	'use strict';

	// We target the new omni-block class instead of the old specific ones.
	document.querySelectorAll('.gardp-posts-block').forEach(initBlock);

	function initBlock(block) {
		var source           = block.dataset.source || '';
		if (!source) {
			if (block.classList.contains('source-current-query')) {
				source = 'current-query';
			} else if (block.classList.contains('source-manual')) {
				source = 'manual';
			} else {
				source = 'dynamic';
			}
		}
		var isCurrentQuery   = source === 'current-query';
		var isManualSource   = source === 'manual';
		var manualPosts      = block.dataset.manualPosts || '';
		var postsPerLoad     = parseInt(block.dataset.postsPerLoad, 10) || 6;
		var layout           = block.dataset.layout || 'uniform';
		var expandFirst      = block.dataset.expandFirst !== '0';
		var readMoreLabel    = block.dataset.readMoreLabel || 'Read full story';
		var cardStyle        = block.dataset.cardStyle || 'default';
		var scopedCategories = block.dataset.scopedCategories || '';
				var scopedProgrammes = block.dataset.scopedProgrammes || '';
		var totalPosts       = parseInt(block.dataset.total, 10) || 0;
				var maxPosts         = parseInt(block.dataset.maxPosts, 10) || 0;
				if (maxPosts > 0) {
					totalPosts = Math.min(totalPosts, maxPosts);
				}
		var showCategory     = block.dataset.showCategory !== '0' ? '1' : '0';
		var showProgramme    = block.dataset.showProgramme !== '0' ? '1' : '0';
		var showDate         = block.dataset.showDate !== '0' ? '1' : '0';
		var showReadMore     = block.dataset.showReadMore !== '0' ? '1' : '0';

		var grid          = block.querySelector('.gardp-posts__grid');
		var btnAll        = block.querySelector('.gardp-posts__filter-all');
		var btnApply      = block.querySelector('.gardp-posts__apply');
		var btnClear      = block.querySelector('.gardp-posts__clear');
		var btnLoadMore   = block.querySelector('.gardp-posts__load-more');
		var loadWrap      = block.querySelector('.gardp-posts__load-more-wrap');
		var dropdowns     = block.querySelectorAll('.gardp-posts__dropdown');
		var tagsContainer = block.querySelector('.gardp-posts__active-tags');
		var itemSelector  = '.gardp-post-card, .gardp-posts__list-item, .gardp-posts__accordion-item';

		block.addEventListener('click', function (e) {
			var accordionTrigger = e.target.closest('.gardp-posts__accordion-trigger');
			if (!accordionTrigger || !block.contains(accordionTrigger)) return;

			e.preventDefault();
			toggleAccordionItem(accordionTrigger);
		});

		if (isCurrentQuery) {
			if (loadWrap) {
				loadWrap.hidden = true;
			}
			openFirstAccordionItem();
			return;
		}

		// State
		var activeFilters = { programme: [], category: [] };
		var filtersApplied = false; // whether any filters are currently applied to the grid

		// ── Dropdown toggle ────────────────────────────────────
		dropdowns.forEach(function (dd) {
			var toggle = dd.querySelector('.gardp-posts__dropdown-toggle');
			var panel  = dd.querySelector('.gardp-posts__dropdown-panel');

			toggle.addEventListener('click', function (e) {
				e.stopPropagation();
				var isOpen = toggle.getAttribute('aria-expanded') === 'true';
				closeAllDropdowns();
				if (!isOpen) {
					toggle.setAttribute('aria-expanded', 'true');
					panel.hidden = false;
				}
			});

			// Prevent closing when clicking inside panel
			panel.addEventListener('click', function (e) {
				e.stopPropagation();
			});
		});

		// Close dropdowns on outside click
		document.addEventListener('click', function () {
			closeAllDropdowns();
		});

		function closeAllDropdowns() {
			dropdowns.forEach(function (dd) {
				dd.querySelector('.gardp-posts__dropdown-toggle').setAttribute('aria-expanded', 'false');
				dd.querySelector('.gardp-posts__dropdown-panel').hidden = true;
			});
		}

		// ── Checkbox changes → update pending state ────────────
		block.addEventListener('change', function (e) {
			if (!e.target.classList.contains('gardp-posts__checkbox')) return;
			syncPendingFilters();
		});

		function syncPendingFilters() {
			var pending = { programme: [], category: [] };
			dropdowns.forEach(function (dd) {
				var filterType = dd.dataset.filter; // "programme" or "category"
				var checked = dd.querySelectorAll('.gardp-posts__checkbox:checked');
				checked.forEach(function (cb) {
					pending[filterType].push(parseInt(cb.value, 10));
				});
				// Toggle active class on dropdown
				if (pending[filterType].length > 0) {
					dd.classList.add('gardp-posts__dropdown--active');
				} else {
					dd.classList.remove('gardp-posts__dropdown--active');
				}
			});

			// Enable Apply if selections changed
			var hasSelection = pending.programme.length > 0 || pending.category.length > 0;
			if (btnApply) btnApply.disabled = !hasSelection;

			return pending;
		}

		// ── Apply ──────────────────────────────────────────────
		if (btnApply) {
			btnApply.addEventListener('click', function () {
				activeFilters = syncPendingFilters();
				filtersApplied = activeFilters.programme.length > 0 || activeFilters.category.length > 0;
				closeAllDropdowns();
				fetchPosts(true);
				renderActiveTags();
				updateUrlParams();

				// Toggle ALL button state
				if (filtersApplied) {
					btnAll.classList.remove('gardp-posts__filter-all--active');
					if (btnClear) btnClear.hidden = false;
				}
			});
		}

		// ── Clear Filters ──────────────────────────────────────
		if (btnClear) {
			btnClear.addEventListener('click', function () {
				resetFilters();
			});
		}

		// ── ALL button ─────────────────────────────────────────
		if (btnAll) {
			btnAll.addEventListener('click', function () {
				resetFilters();
			});
		}

		function resetFilters() {
			// Uncheck all checkboxes
			block.querySelectorAll('.gardp-posts__checkbox:checked').forEach(function (cb) {
				cb.checked = false;
			});
			dropdowns.forEach(function (dd) {
				dd.classList.remove('gardp-posts__dropdown--active');
			});
			activeFilters = { programme: [], category: [] };
			filtersApplied = false;
			if (btnApply) btnApply.disabled = true;
			if (btnClear) btnClear.hidden = true;
			btnAll.classList.add('gardp-posts__filter-all--active');
			closeAllDropdowns();
			clearActiveTags();
			updateUrlParams();
			fetchPosts(true);
		}

		// ── Active filter tags ─────────────────────────────────
		function renderActiveTags() {
			if (!tagsContainer) return;
			tagsContainer.innerHTML = '';

			block.querySelectorAll('.gardp-posts__checkbox:checked').forEach(function (cb) {
				var tag = document.createElement('span');
				tag.className = 'gardp-posts__tag';
				tag.setAttribute('data-filter', cb.closest('.gardp-posts__dropdown').dataset.filter);
				tag.setAttribute('data-value', cb.value);

				var label = document.createElement('span');
				label.className = 'gardp-posts__tag-label';
				label.textContent = cb.dataset.label || cb.value;

				var removeBtn = document.createElement('button');
				removeBtn.className = 'gardp-posts__tag-remove';
				removeBtn.setAttribute('type', 'button');
				removeBtn.setAttribute('aria-label', 'Remove ' + (cb.dataset.label || cb.value));
				removeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

				tag.appendChild(label);
				tag.appendChild(removeBtn);
				tagsContainer.appendChild(tag);
			});

			tagsContainer.hidden = tagsContainer.children.length === 0;
		}

		function clearActiveTags() {
			if (!tagsContainer) return;
			tagsContainer.innerHTML = '';
			tagsContainer.hidden = true;
		}

		function setAccordionExpanded(trigger, expanded) {
			if (!trigger) return;

			var item = trigger.closest('.gardp-posts__accordion-item');
			var panel = item ? item.querySelector('.gardp-posts__accordion-panel') : null;
			var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

			trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
			if (item) item.classList.toggle('is-expanded', expanded);

			if (!panel) return;

			if (prefersReducedMotion) {
				panel.hidden = !expanded;
				panel.style.height = '';
				return;
			}

			panel.style.overflow = 'hidden';
			panel.style.willChange = 'height, opacity, transform';

			if (expanded) {
				panel.hidden = false;
				panel.style.height = '0px';
				panel.offsetHeight;
				panel.style.height = panel.scrollHeight + 'px';

				var onExpandEnd = function (event) {
					if (event.propertyName !== 'height') return;
					panel.style.height = 'auto';
					panel.style.overflow = '';
					panel.style.willChange = '';
					panel.removeEventListener('transitionend', onExpandEnd);
				};

				panel.removeEventListener('transitionend', onExpandEnd);
				panel.addEventListener('transitionend', onExpandEnd);
				return;
			}

			if (panel.hidden) {
				panel.style.height = '';
				panel.style.overflow = '';
				panel.style.willChange = '';
				return;
			}

			panel.style.height = panel.scrollHeight + 'px';
			panel.offsetHeight;
			panel.style.height = '0px';

			var onCollapseEnd = function (event) {
				if (event.propertyName !== 'height') return;
				panel.hidden = true;
				panel.style.height = '';
				panel.style.overflow = '';
				panel.style.willChange = '';
				panel.removeEventListener('transitionend', onCollapseEnd);
			};

			panel.removeEventListener('transitionend', onCollapseEnd);
			panel.addEventListener('transitionend', onCollapseEnd);
		}

		function openFirstAccordionItem() {
			if (layout !== 'accordion' || !grid || !expandFirst) return;

			var expandedTrigger = grid.querySelector('.gardp-posts__accordion-trigger[aria-expanded="true"]');
			if (expandedTrigger) return;

			var firstTrigger = grid.querySelector('.gardp-posts__accordion-trigger');
			if (firstTrigger) {
				setAccordionExpanded(firstTrigger, true);
			}
		}

		function toggleAccordionItem(trigger) {
			if (layout !== 'accordion' || !grid) return;

			var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
			grid.querySelectorAll('.gardp-posts__accordion-trigger').forEach(function (otherTrigger) {
				if (otherTrigger !== trigger) {
					setAccordionExpanded(otherTrigger, false);
				}
			});

			setAccordionExpanded(trigger, !isExpanded);
		}

		// Handle tag removal
		if (tagsContainer) {
			tagsContainer.addEventListener('click', function (e) {
				var removeBtn = e.target.closest('.gardp-posts__tag-remove');
				if (!removeBtn) return;

				var tag = removeBtn.closest('.gardp-posts__tag');
				var filterType = tag.dataset.filter;
				var value = tag.dataset.value;

				// Uncheck the matching checkbox
				var checkbox = block.querySelector(
					'.gardp-posts__dropdown[data-filter="' + filterType + '"] ' +
					'.gardp-posts__checkbox[value="' + value + '"]'
				);
				if (checkbox) checkbox.checked = false;

				// Re-sync and re-apply
				activeFilters = syncPendingFilters();
				filtersApplied = activeFilters.programme.length > 0 || activeFilters.category.length > 0;

				if (!filtersApplied) {
					btnAll.classList.add('gardp-posts__filter-all--active');
					if (btnClear) btnClear.hidden = true;
					if (btnApply) btnApply.disabled = true;
				}

				fetchPosts(true);
				renderActiveTags();
				updateUrlParams();
			});
		}

		// ── Load More ──────────────────────────────────────────
		if (btnLoadMore) {
			btnLoadMore.addEventListener('click', function () {
				fetchPosts(false);
			});
		}

		// ── Fetch posts via REST ───────────────────────────────
		function fetchPosts(replace) {
			if (!grid) {
				return;
			}

			if (isManualSource) {
				if (!manualPosts) {
					return;
				}
			}

			var currentlyShown = replace ? 0 : grid.querySelectorAll(itemSelector).length;
			var perPage = postsPerLoad;

			var params = new URLSearchParams();
			params.append('offset', currentlyShown);
			params.append('per_page', perPage);
			params.append('layout', layout);
			params.append('expand_first', expandFirst ? '1' : '0');
			params.append('card_style', cardStyle);
			params.append('read_more_label', readMoreLabel);
			params.append('show_category', showCategory);
			params.append('show_programme', showProgramme);
			params.append('show_date', showDate);
			params.append('show_read_more', showReadMore);

			if (isManualSource) {
				params.append('manual_posts', manualPosts);
			} else {
				if (activeFilters.programme.length) {
					params.append('programme', activeFilters.programme.join(','));
				}
				if (activeFilters.category.length) {
					params.append('category', activeFilters.category.join(','));
				}
				if (scopedCategories) {
					params.append('scoped_categories', scopedCategories);
				}
				if (scopedProgrammes) {
					params.append('scoped_programmes', scopedProgrammes);
				}
			}

			var url = (window.gardpPostsOpts && window.gardpPostsOpts.restUrl)
				? window.gardpPostsOpts.restUrl
				: '/wp-json/gardp/v1/posts-query';

			if (btnLoadMore) btnLoadMore.classList.add('is-loading');

			fetch(url + '?' + params.toString())
			.then(function (res) {
				if (!res.ok) throw new Error('HTTP ' + res.status);
				return res.json();
			})
			.then(function (data) {
				if (replace) {
					grid.innerHTML = data.html || '';
					openFirstAccordionItem();
				} else {
					grid.insertAdjacentHTML('beforeend', data.html || '');
				}

				totalPosts = parseInt(data.total, 10) || 0;
                                if (maxPosts > 0) { totalPosts = Math.min(totalPosts, maxPosts); }
				var shown = grid.querySelectorAll(itemSelector).length;

				// Show empty state when no results
				if (totalPosts === 0 && replace) {
					grid.innerHTML =
						'<div class="gardp-posts__empty">' +
							'<p class="gardp-posts__empty-heading">No results found</p>' +
							'<p class="gardp-posts__empty-text">Try adjusting or clearing your filters to see more results.</p>' +
						'</div>';
				}

				if (btnLoadMore && loadWrap) {
					if (shown >= totalPosts) {
						loadWrap.hidden = true;
					} else {
						loadWrap.hidden = false;
					}
				}
			})
			.catch(function (err) {
				console.error('Filterable Posts fetch error:', err);
			})
			.finally(function () {
				if (btnLoadMore) btnLoadMore.classList.remove('is-loading');
			});
		}

		// ── URL param sync ──────────────────────────────────────
		function getCheckedSlugs(filterType) {
			var slugs = [];
			var dd = block.querySelector('.gardp-posts__dropdown[data-filter="' + filterType + '"]');
			if (!dd) return slugs;
			dd.querySelectorAll('.gardp-posts__checkbox:checked').forEach(function (cb) {
				if (cb.dataset.slug) slugs.push(cb.dataset.slug);
			});
			return slugs;
		}

		function updateUrlParams() {
			var programmeSlugs = getCheckedSlugs('programme');
			var categorySlugs  = getCheckedSlugs('category');
			var parts = [];

			if (programmeSlugs.length) parts.push('programme=' + programmeSlugs.join(','));
			if (categorySlugs.length)  parts.push('category=' + categorySlugs.join(','));

			var newUrl = window.location.pathname + (parts.length ? '?' + parts.join('&') : '');
			history.replaceState(null, '', newUrl);
		}

		// ── Pre-filter from URL on page load ────────────────────
		function applyUrlPrefilters() {
			var url = new URL(window.location);
			var programmeSlugs = (url.searchParams.get('programme') || '').split(',').filter(Boolean);
			var categorySlugs  = (url.searchParams.get('category') || '').split(',').filter(Boolean);

			if (!programmeSlugs.length && !categorySlugs.length) return;

			// Check matching checkboxes by slug
			function checkBySlug(filterType, slugs) {
				var dd = block.querySelector('.gardp-posts__dropdown[data-filter="' + filterType + '"]');
				if (!dd) return;
				slugs.forEach(function (slug) {
					var cb = dd.querySelector('.gardp-posts__checkbox[data-slug="' + slug + '"]');
					if (cb) cb.checked = true;
				});
			}

			checkBySlug('programme', programmeSlugs);
			checkBySlug('category', categorySlugs);

			// Sync state as if Apply was clicked
			activeFilters = syncPendingFilters();
			filtersApplied = activeFilters.programme.length > 0 || activeFilters.category.length > 0;

			if (filtersApplied) {
				btnAll.classList.remove('gardp-posts__filter-all--active');
				if (btnClear) btnClear.hidden = false;
				renderActiveTags();
				fetchPosts(true);
			}
		}

		applyUrlPrefilters();
		openFirstAccordionItem();
	}
})();
jQuery(document).ready(function($) {
	if (typeof window.GardpSliderHelper !== 'function') {
		return;
	}

	window.GardpSliderHelper.initElements(
		$('.gardp-latest-posts--slider .gardp-latest-posts__grid'),
		function(element) {
			return {
				partialView: $(element).closest('.gardp-latest-posts--partial-view').length > 0,
			};
		}
	);
});
